import React from 'react'
import { Card, CardContent, Typography, Chip, Box } from '@mui/material'
import { Email, Sms, WhatsApp } from '@mui/icons-material'

const CardTipoEnvio = ({ dados }) => {
  const tipo = (dados?.tpEnvio || '').toUpperCase()

  const getConfiguracao = () => {
    switch (tipo) {
      case 'E':
        return {
          label: 'E-mail',
          color: 'success',
          icon: <Email sx={{ color: '#fff !important' }} />,
        }

      case 'W':
        return {
          label: 'WhatsApp',
          color: 'success',
          icon: <WhatsApp sx={{ color: '#fff !important' }} />,
        }

      case 'S':
        return {
          label: 'SMS',
          color: 'success',
          icon: <Sms sx={{ color: '#fff !important' }} />,
        }

      default:
        return {
          label: 'Não informado',
          color: 'default',
          icon: <Sms sx={{ color: '#fff !important' }} />,
        }
    }
  }

  const config = getConfiguracao()

  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 3,
      }}
    >
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Tipo de Envio
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'start',
            mt: 1,
          }}
        >
          <Chip
            icon={config.icon}
            label={config.label}
            color={config.color}
            size="medium"
            sx={{
              '& .MuiChip-label': {
                color: '#fff',
                fontWeight: 600,
              },
              '& .MuiChip-icon': {
                color: '#fff',
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  )
}

export default CardTipoEnvio
